import { Irrigation, irrigationAdapter, IrrigationState } from "./irrigation.entity";
import { ToroControllerBundle } from '../../api/models/toro-controller-bundle';
import { createReducer, on, Action, combineReducers } from '@ngrx/store';
import * as controllerReducers from './controllers/controller.reducer';
import { controllerAdapter } from "./controllers/controller.entity";

export const initialState = irrigationAdapter.getInitialState({
    controllers: controllerReducers.initialState
});


export function irrigationReducer(state: IrrigationState = initialState, action: Action): IrrigationState {
    return combineReducers({
        controllers: controllerReducers.reducer
    })(state, action) as IrrigationState;
}

export const controllerSelectors = controllerAdapter.getSelectors();
